const DAY_NAMES = ['일', '월', '화', '수', '목', '금', '토'];

/**
 * YYYY-MM-DD 문자열 → "3월 8일 (토)" 형태
 * @param {string} dateStr - "2026-03-08" 형태
 * @param {object} opts
 * @param {boolean} opts.showYear - 연도 표시 (기본: false, 올해가 아니면 자동 표시)
 * @param {boolean} opts.showDay - 요일 표시 (기본: true)
 * @param {boolean} opts.showTime - 시간 표시 (기본: false)
 * @param {string} opts.time - "09:00" 형태 시간 (showTime=true 일 때)
 */
export function friendlyDate(dateStr, opts = {}) {
  if (!dateStr) return '';
  const { showYear, showDay = true, showTime = false, time } = opts;

  // YYYY-MM-DD 파싱
  const parts = String(dateStr).slice(0, 10).split('-');
  if (parts.length < 3) return dateStr;

  const y = Number(parts[0]);
  const m = Number(parts[1]);
  const d = Number(parts[2]);
  if (!y || !m || !d) return dateStr;

  const thisYear = new Date().getFullYear();
  const needYear = showYear || y !== thisYear;

  const date = new Date(y, m - 1, d);
  const dayName = DAY_NAMES[date.getDay()] || '';

  let result = needYear ? `${y}년 ${m}월 ${d}일` : `${m}월 ${d}일`;
  if (showDay) result += ` (${dayName})`;
  if (showTime && time) result += ` ${time}`;

  return result;
}

/**
 * Firestore Timestamp 또는 Date → "3월 8일 (토)" 형태
 */
export function friendlyTimestamp(ts, opts = {}) {
  if (!ts) return '';
  let date;
  if (ts.seconds) {
    date = new Date(ts.seconds * 1000);
  } else if (ts.toDate) {
    date = ts.toDate();
  } else if (ts instanceof Date) {
    date = ts;
  } else {
    return friendlyDate(String(ts), opts);
  }
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  const hh = String(date.getHours()).padStart(2, '0');
  const mm = String(date.getMinutes()).padStart(2, '0');
  const mergedOpts = { ...opts };
  if (opts.showTime !== false && (hh !== '00' || mm !== '00')) {
    mergedOpts.showTime = true;
    mergedOpts.time = `${hh}:${mm}`;
  }
  return friendlyDate(`${y}-${m}-${d}`, mergedOpts);
}

/**
 * YYYY-MM-DD → YYYY-MM-DD (내부 비교/저장용, 변환 없음)
 */
export function toLocalDateStr(date) {
  const d = date instanceof Date ? date : new Date(date);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${dd}`;
}
